import parseURL from 'url-parse';

function getSiteFromURI(uri) {
  const parsed = parseURL(uri);
  const siteLookup = {
    'www.fastcompany.com': 'Fast Company',
    'www.fastcodesign.com': 'Co.Design'
  };

  return siteLookup[parsed.host] || '';
}

export default getSiteFromURI;



// WEBPACK FOOTER //
// ./src/utils/get_site_from_uri_util.js